<script setup>
import { useAppLayout } from '@/use'

defineProps({
  logoImage: { type: String, default: '' },
})

const appLayout = useAppLayout()
const { layoutState } = appLayout

const reportMenuItems = [
  {
    group: 'Accounting',
    items: [
      { label: 'Client Billing',           route: '/reports/client-billing',                       isActive: true  },
      { label: 'Approved Timesheet',       route: '/reports/approved-timesheets',          isActive: true  },
      { label: 'Expected Commissions',     route: '/reports/expected-commissions',         isActive: false },
      { label: 'Conversions',              route: '/reports/conversions',                  isActive: true  },
    ]
  },
  {
    group: 'Tours',
    items: [
      { label: 'Tour History',             route: '/reports/tour-history',                 isActive: true  },
      { label: 'Tour Count by Person',     route: '/reports/tour-count-by-person',                   isActive: true  },
      { label: 'Canceled Tours',           route: '/reports/tour-canceled',                isActive: false },
      { label: 'Tour Feedback',            route: '/reports/tour-feedback',                isActive: true },
      { label: 'Export Tours',             route: '/reports/tour-export',                  isActive: false },
      { label: 'Export Tours (Plus Relo)', route: '/reports/tour-export?relo_company_id=3', isActive: false },
    ]
  },
  {
    group: 'Admin / Other',
    items: [
      { label: 'Email Previews',           route: '/reports/email-previews',               isActive: true  },
      { label: 'Citizenship',              route: '/reports/citizenship',                  isActive: false },
      { label: 'DC Initiations',           route: '/reports/dc-initiations',               isActive: true  },
      { label: 'Realtors Report',          route: '/reports/realtors-report',              isActive: false },
      { label: 'Survey Report',            route: '/reports/survey-report',                isActive: false },
      { label: 'App Activity',             route: '/reports/app-activity',                 isActive: false },
    ]
  },
]
</script>

<template lang="pug">
Drawer(v-model:visible="layoutState.showReportsDrawer" header="Reports" position="left")
  template(#header)
    .flex.items-center.gap-4
      img.logo-image(:src="logoImage" width="40px" height="40px")
      .text-normal.text-canvas-400.font-bold Reports

  .ml-2
    ul.admin-link-list.my-4(v-for="{group, items} in reportMenuItems" :key="group")
      li.admin-group-label.font-bold.text-canvas-500.pb-3 {{ group }}
      li.flex(v-for="link in items" :key="link.label")
        a.admin-link.font-semibold(
          :href="link.route"
          :class="link.isActive ? 'text-accent' : 'text-canvas-400'"
        )
          span.mr-2: i.ph.ph-table
          span {{ link.label }}
</template>
